module.exports = __webpack_public_path__ + "img/Card_heart_8.cfd0bfb5.svg";